import { createAction, createAsyncAction } from "typesafe-actions";
const domain = "download";
const downloadActions = {
  fetchDownloadData: createAsyncAction(
    `${domain}/fetchDownloadDataRequest`,
    `${domain}/fetchDownloadDataSuccess`,
    `${domain}/fetchDownloadDataFailed`
  )(),
  startDownload: createAction(`${domain}/startDownload`)(),
  downloadFile: createAction(`${domain}/downloadFile`)()
};
export {
  downloadActions
};
//# sourceMappingURL=actions.js.map
